import * as React from "react";

const Building = ({ fill, size }: { fill?: string; size?: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="building"
    width={size?size:"24"}
    height={size?size:"24"}
    x="0"
    y="0"
    fill={fill?fill:"#2c2c2c"}
    version="1.1"
    viewBox="0 0 32 32"
  >
    <path d="M20 4h2v2h-2zm4 0h2v2h-2zm-4 4h2v2h-2zm4 0h2v2h-2zm-4 4h2v2h-2zm4 0h2v2h-2zm-4 4h2v2h-2zm4 0h2v2h-2zm-4 4h2v2h-2zm4 0h2v2h-2zm4-20H18a2 2 0 0 0-2 2v6H6a2 2 0 0 0-2 2v20a2 2 0 0 0 2 2h22a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2M12 30h-2v-4h2zm2 0v-6H8v6H6V10h10v20zm10 0h-2v-4h2zm4 0h-2v-6h-6v6h-2V2h10zM8 12h2v2H8zm4 0h2v2h-2zm-4 4h2v2H8zm4 0h2v2h-2zm-4 4h2v2H8zm4 0h2v2h-2z"></path>
  </svg>
);

export default Building;
